

















import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
})
export default class EyeIcon extends Vue {
  eyeOpen = require('../../assets/icons/eye-common.svg');

  eyeClosed = require('../../assets/icons/eye-crossed.svg');
}
